<script lang="ts">
  import { Button } from "$lib/components/ui/button";
  import { projectDraft } from "$src/application/projects/stores/projectStore";
  import { ShoppingCart } from "lucide-svelte";
  import { t } from "svelte-i18n";

  export let orderProjectDemand: () => void;
</script>

{#if $projectDraft.currentStep?.id == 1}
  <Button variant="secondary" on:click={orderProjectDemand}>
    <ShoppingCart class="md:mr-2 h-4 w-4" />
    <p class="hidden md:flex">
      {$t("page.projects.actions.order-project")}
    </p>
  </Button>
{/if}
